// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,

    apiUrl: 'https://mydev-api.greencountry.com.ua/api',
    webUrl: 'https://mydev-api.greencountry.com.ua/',
    host: 'https://myapp.greencountry.com.ua/',

    esputnikUserName:'school@greencountry.com.ua',
    esputnikPassword: 'GCschool2006',
    esputnikBaseUrl: 'https://esputnik.com/api/v1',
    esputnikApiSecret: 'D1FD96FF151516DC437889B666DED61E',
    esputnikInboxUrl: 'https://esputnik.com/appinbox/v1',

    appVersion: '2.0.11',

    retenoEnable: false,
    retenoApiKey: 'f8937997-3e72-4872-84c5-50605bb8c203',
    retenoDebugMode: false,
    recaptchaSiteKey: '6Le2yVwtAAAAAJwtjldekc4p8NyhpnRaJycXzfLa',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
